export default __webpack_public_path__ + "static/zdenek-rezler-2b955174d2d0b4b20fde445a4ed7a08e.jpg";